var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3601 2508)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(3601 -2508)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3128.222 -3209.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.477,743.645q0,3.49,0,6.98a4.158,4.158,0,0,1-1.019,2.9,3.824,3.824,0,0,1-2.59,1.3c-.513.045-1.032.05-1.548.051q-5.054.007-10.109,0a4.331,4.331,0,0,1-2.276-.569,3.939,3.939,0,0,1-1.957-3.245c-.013-.163-.016-.327-.016-.491q0-7.083,0-14.167a1.945,1.945,0,0,1,.052-.51.768.768,0,0,1,.764-.543.751.751,0,0,1,.738.576,2.134,2.134,0,0,1,.05.485q0,7.123,0,14.245a2.484,2.484,0,0,0,.966,2.1,2.632,2.632,0,0,0,1.623.511q5.559.01,11.117,0a2.475,2.475,0,0,0,2.589-2.613q0-7.123,0-14.245a2.092,2.092,0,0,1,.042-.435.753.753,0,0,1,.775-.624.777.777,0,0,1,.774.695,2.694,2.694,0,0,1,.016.361Q506.478,740.026,506.477,743.645Z",
    transform: "translate(-5.551 -22.191)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.171,711.5H480.858a2.725,2.725,0,0,1-.412-.02.777.777,0,0,1-.668-.771.752.752,0,0,1,.625-.773,2,2,0,0,1,.408-.043q2.21,0,4.42,0a.42.42,0,0,0,.387-.186c.511-.693,1.037-1.374,1.558-2.061a2.48,2.48,0,0,1,2.053-1.011c1.3-.012,2.6-.016,3.9,0a2.45,2.45,0,0,1,2.027,1c.517.689,1.046,1.369,1.558,2.061a.419.419,0,0,0,.384.191q2.248-.01,4.5,0c.555,0,.833.2.932.66a.76.76,0,0,1-.608.922,2.4,2.4,0,0,1-.437.026Zm3.678-1.616c-.311-.423-.6-.8-.868-1.182a1.011,1.011,0,0,0-.874-.458q-1.937,0-3.874,0a1.006,1.006,0,0,0-.876.455c-.235.34-.484.669-.725,1-.036.051-.062.108-.1.181Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.835,752.62q0-2.713,0-5.427a2.349,2.349,0,0,1,.038-.436.789.789,0,0,1,1.538-.008,1.947,1.947,0,0,1,.039.384q0,5.5,0,11.009c0,.582-.195.867-.652.969a.757.757,0,0,1-.926-.6,2.154,2.154,0,0,1-.038-.41Q504.833,755.359,504.835,752.62Z",
    transform: "translate(-19.362 -30.527)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.449,752.661q0,2.752,0,5.5c0,.579-.2.865-.657.965a.766.766,0,0,1-.919-.585,1.742,1.742,0,0,1-.04-.358q0-5.53,0-11.06c0-.591.24-.9.721-.96a.748.748,0,0,1,.861.63,2.384,2.384,0,0,1,.034.41Q549.451,749.934,549.449,752.661Z",
    transform: "translate(-52.586 -30.545)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.352,752.622q0-2.777,0-5.555c0-.512.2-.81.6-.9a.769.769,0,0,1,.976.631,1.442,1.442,0,0,1,.022.282q0,5.555,0,11.11c0,.483-.168.767-.518.889a.788.788,0,0,1-1.083-.774c-.013-.344,0-.689,0-1.033Z",
    transform: "translate(-35.986 -30.531)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ce6baf1c.svg";
export { ForwardRef as ReactComponent };